import { EventLog_CustomerEventFragment as EventData } from "@bonliva-crm/graphql";
import { makeStyles } from "@material-ui/core";
import { ThemeType } from "@theme";
import { transparentize } from "polished";
import { store } from "@store";
import UserAvatar from "@containers/UserAvatar";
import locale from "@bonliva-crm/locale";
import CalendarTodayIcon from "@material-ui/icons/CalendarToday";
import moment from "moment";
import { SubParagraph } from "@common/typography/SubParagraph";
import React from "react";
import { Event } from "@containers/EventLog/Event/Event";
import NotifIcon from "@material-ui/icons/NotificationImportantRounded";
import { StyledHtml } from "@common/StyledHtml";

type Props = {
  item: EventData;
};

function TodoParams(props: Props) {
  const classes = useStyle({});
  const { TodoItem } = props.item;

  if (!TodoItem) {
    return null;
  }

  const assignedTo = () => {
    if (TodoItem.AssignedTo && TodoItem.AssignedTo.PersonId !== store().user.id) {
      return (
        <div data-test="ReminderEventAssignedTo" className={classes.subtitleEl}>
          <div className={classes.subTitleLabel}>
            <UserAvatar
              userName={TodoItem.AssignedTo.Name}
              size="micro"
              style={{ marginRight: 4 }}
            />
            {locale["Assigned to"]}:
          </div>
          <div className={classes.subTitleValue}>
            <strong>{TodoItem.AssignedTo.Name}</strong>
          </div>
        </div>
      );
    } else if (TodoItem.AssignedTeam) {
      return (
        <div data-test="ReminderEventAssignedTo" className={classes.subtitleEl}>
          <div className={classes.subTitleLabel}>{locale["Assigned to"]}:</div>
          <div className={classes.subTitleValue}>
            <strong>{TodoItem.AssignedTeam}</strong>
          </div>
        </div>
      );
    }
  };

  const completed = (
    <div data-test="ReminderEventCompleted" className={classes.subtitleEl}>
      <div className={classes.subTitleLabel}>{locale.Completed}:</div>
      <div className={classes.subTitleValue}>
        {TodoItem.Completed ? locale.Yes : locale.No}
      </div>
    </div>
  );

  const due = TodoItem.Due ? (
    <div data-test="ReminderEventDue" className={classes.subtitleEl}>
      <div className={classes.subTitleLabel}>
        <CalendarTodayIcon fontSize="inherit" />
        {locale.DueDate}:
      </div>
      <div className={classes.subTitleValue}>{moment(TodoItem.Due).calendar()}</div>
    </div>
  ) : null;

  return (
    <SubParagraph style={{ display: "flex", flex: 1 }}>
      {assignedTo()} {due} {completed}
    </SubParagraph>
  );
}

export function ReminderEvent(props: Props) {
  const { item } = props;
  return (
    <Event item={item} key={props.item._id} icon={<NotifIcon />}>
      <TodoParams item={item} />
      <StyledHtml>{item.DescriptionHtml ?? ""}</StyledHtml>
    </Event>
  );
}

const useStyle = makeStyles((theme: ThemeType) => ({
  todoParams: {
    marginBottom: theme.spacing()
  },

  subtitleEl: {
    alignItems: "center",
    borderRadius: 4,
    display: "flex",
    // flex: 1,
    flexWrap: "wrap",
    marginLeft: 4,
    marginTop: -2,
    marginBottom: -2,
    padding: 2,
    backgroundColor: transparentize(0.88, theme.palette.secondary.light),
    border: `1px solid ${transparentize(0.83, theme.palette.secondary.light)}`,

    "&:first-child": {
      marginLeft: 0
    },

    "& > div": {
      marginRight: 4
    },

    "& svg": {
      marginRight: 4
    }
  },

  subTitleLabel: {
    alignItems: "center",
    display: "flex"
  },

  subTitleValue: {
    flex: 1,
    whiteSpace: "nowrap"
  }
}));
